export default __webpack_public_path__ + "static/media/iphone2_web.9a6b84a5.png";